import { Company as PromoterCompany } from '../Promoter/company';

export class SocialRegisterRequestModel {
    public token: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone?: string | null | undefined;
    public pictureUrl?: string | null | undefined;
    public languageId: null | string;
    // public country?: null | string;
    // public countryCode?: null | string;
    // public city?: null | string;
    // public googlePlaceId?: null | string;
    // public termsOfConditionsAccepted?: null | boolean;//this is needed
    // public termsOfConditionsVersion?: null | string;//this is needed
    // public company: PromoterCompany;
    // public businessTypesIds?: null | Array<number>;
}
